import apiClient from './apiClient';
import { GET_PAGE_ORDER, UPDATE_PAGE_ORDER } from '../constants/UriConstants';

export interface PageOrderResponse {
  // Page keys in saved display order. Empty when the restaurant has never reordered.
  order: string[];
}

export const getPageOrder = (): Promise<string[]> =>
  apiClient.get(GET_PAGE_ORDER).then((response) => (response.data as PageOrderResponse)?.order ?? []);

export const updatePageOrder = (order: string[]): Promise<string[]> =>
  apiClient.put(UPDATE_PAGE_ORDER, { order }).then((response) => (response.data as PageOrderResponse)?.order ?? []);
